import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export const ResourcePage = () => {
  const [scrolled, setScrolled] = useState(false);
  const {
    resourceId
  } = useParams();
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-6416">
      <Navbar scrolled={scrolled} data-id="element-6417" />
      <main className="pt-24 pb-20" data-id="element-6418">
        <div className="container mx-auto px-4 md:px-6" data-id="element-6419">
          <div className="max-w-6xl mx-auto" data-id="element-6420">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-[#F8FAF9]" data-id="element-6421">
              Resource Details
            </h1>
            <p className="text-gray-600 dark:text-[#B0C1BD]" data-id="element-6422">
              View details for resource {resourceId}
            </p>
          </div>
        </div>
      </main>
      <Footer data-id="element-6423" />
    </div>;
};